import { render, staticRenderFns } from "./LecturerComments.vue?vue&type=template&id=0c2d0d43&scoped=true&"
import script from "./LecturerComments.vue?vue&type=script&lang=js&"
export * from "./LecturerComments.vue?vue&type=script&lang=js&"
import style0 from "./LecturerComments.vue?vue&type=style&index=0&id=0c2d0d43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d0d43",
  null
  
)

export default component.exports